import { TagListItem } from '@/models/dictionary/tag-list.model';
import { SegmentListItem } from '@/models/dictionary/segment-list.model';

export type DocumentListFilter = {
  countryList?: string[];
  countryListCondition?: string;
  tagIdList?: string[];
  tagIdListCondition?: string;
  segmentIdList?: string[];
  segmentIdListCondition?: string;
  minTotalAmountEur?: string | null;
  maxTotalAmountEur?: string | null;
  moderationStatus?: string;
}

export enum DocumentListFilterProperties {
  SEGMENT_ID_LIST_CONDITION = 'segmentIdListCondition',
  TAG_ID_LIST_CONDITION = 'tagIdListCondition',
  COUNTRY_LIST_CONDITION = 'countryListCondition',
  MIN_TOTAL_AMOUNT_EUR = 'minTotalAmountEur',
  MAX_TOTAL_AMOUNT_EUR = 'maxTotalAmountEur',
}

export type DocumentListFilterFormData = {
  countryList: string[];
  countryListCondition: string;
  tagList: TagListItem[];
  tagIdListCondition: string;
  segmentList: SegmentListItem[];
  segmentIdListCondition: string;
  minTotalAmountEur: string | null;
  maxTotalAmountEur: string | null;
  moderationStatus: string;
}
